import React, { useEffect, useState } from "react";
import {
  PictureOutlined,
  UploadOutlined,
  CaretRightFilled,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "antd/es/modal/style";
import "antd/es/slider/style";
import { Modal, Progress, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { useContext } from "react";
import FileKeysContext from "../../context/fileKeysContext";
import axios from "axios";
import UploadingProcessContext from "../../context/uploadingProcessContext";
import { toast } from "react-toastify";

const CustomUploader = ({ type, files, setClearList, clearList }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewVideo, setPreviewVideo] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);

  // for edit mode
  const [newKey, setNewKey] = useState(null);
  const [oldKey, setOldKey] = useState(null);
  //
  const {
    multipleImagesKeys,
    multipleVideosKeys,
    newOldKeys,
    multipleImagesKeysAction,
    singleDocKeyAction,
    featuredImageKeyAction,
    videoKeyAction,
    videoCoverKeyAction,
    multipleVideosKeysAction,
    newOldKeysAction,
    newOldVideoCoverKeyAction,
    newOldFeaturedImageKeyAction,
    newOldDocumentKeyAction,
    shopImagesKeys,
    shopImagesKeysAction,
  } = useContext(FileKeysContext);

  const { uploadingAction } = useContext(UploadingProcessContext);

  useEffect(() => {
    if (clearList === true) {
      setFileList([]);
      setClearList(false);
    }
  }, [setFileList, clearList, setClearList]);

  const customRequest = async (options) => {
    // set uploading true to disable ok button in modal
    uploadingAction(true);

    const { file, onSuccess, onError, onProgress } = options;

    const isLt5M =
      type === "video" || type === "multiple-video"
        ? (file.size / (1024 * 1024)) * 10 <= 10
        : (file.size / (1024 * 1024)) * 10 <= 5;
    if (!isLt5M) {
      uploadingAction(false);
      onError(
        toast.error(
          type === "video" || type === "multiple-video"
            ? "حجم فایل باید کمتر از   50 مگابایت باشد"
            : "حجم فایل باید کمتر از   5 مگابایت باشد"
        )
      );
      return;
    }

    try {
      // send file name to get upload info
      const response = await axios.post(
        process.env.REACT_APP_EXPERT_BASE_URL + "/files/s3-upload-file",
        { filename: file?.name }
      );
      // destructure upload info
      const { url, fields } = response?.data?.result?.data;
      const { key } = fields; // key is in fields
      setNewKey(key);
      // create formdata
      let formData = new FormData();
      Object.entries(fields).map(([key, value]) => {
        return formData.append(key, value);
      });
      formData.append("file", file);

      // progress tracking config
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted); // Update the upload progress
          onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
        },
      };

      // upload formdata to Arvan cloud
      const arvanResponse = await axios.post(url, formData, config);
      // set context data
      // edit mode
      if (files) {
        if (
          type === "shop-image" ||
          type === "multiple-image" ||
          type === "other-images" ||
          type === "video" ||
          type === "multiple-video"
        )
          newOldKeysAction([...newOldKeys, { newKey: key, oldKey: oldKey }]);
        if (type === "video-cover") newOldVideoCoverKeyAction(key);
        if (type === "featured-image") newOldFeaturedImageKeyAction(key);
        if (type === "single-doc") newOldDocumentKeyAction(key);
      }
      // new mode
      else {
        if (type === "shop-image")
          shopImagesKeysAction([...shopImagesKeys, key]);
        if (type === "multiple-image" || type === "other-images")
          multipleImagesKeysAction([...multipleImagesKeys, key]);
        if (type === "multiple-video")
          multipleVideosKeysAction([...multipleVideosKeys, key]);
        if (type === "single-doc") singleDocKeyAction(key);
        if (type === "featured-image") featuredImageKeyAction(key);
        if (type === "video") videoKeyAction(key);
        if (type === "video-cover") videoCoverKeyAction(key);
      }
      // add originFileObj and key to file
      file.originFileObj = file;
      file.key = key;

      setFileList([...fileList, file]);

      uploadingAction(false);
      // call onSuccess
      onSuccess(arvanResponse?.data);
    } catch (error) {
      uploadingAction(false);
      onError(error);
    }
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name);
  };

  useEffect(() => {
    if (files) {
      const dflist = files.map((file, i) => {
        return {
          uid: i.toString(),
          name: file.substring(file.lastIndexOf("/") + 1),
          status: "done",
          url: process.env.REACT_APP_ARVAN_S3_BASE_URL + file,
        };
      });
      setFileList(dflist);
    }
  }, [files?.length]);

  useEffect(() => {
    if (files && files?.length > 0) {
      if (type === "video" || type === "multiple-video") {
        setPreviewTitle(files[0]?.name ? files[0].name : files[0]);
        setPreviewVideo(process.env.REACT_APP_ARVAN_S3_BASE_URL + files[0]);
      }
    }
  }, [files]);

  const onRemove = (file) => {
    return new Promise((resolve, reject) => {
      // edit mode
      if (files) {
        setFileList(fileList.filter((f) => f?.uid !== file?.uid));
        if (
          type === "shop-image" ||
          type === "multiple-image" ||
          type === "other-images" ||
          type === "video" ||
          type === "multiple-video"
        ) {
          // old files
          if (file?.url) {
            newOldKeysAction([
              ...newOldKeys,
              {
                newKey: null,
                oldKey: file?.url?.replace(
                  process.env.REACT_APP_ARVAN_S3_BASE_URL,
                  ""
                ),
              },
            ]);
          }
          // new files
          else {
            newOldKeysAction([
              ...newOldKeys,
              { newKey: null, oldKey: file?.key },
            ]);
          }
        }

        if (type === "video-cover") {
          newOldVideoCoverKeyAction("");
        }
        if (type === "featured-image") {
          newOldFeaturedImageKeyAction("");
        }
        if (type === "single-doc") {
          newOldDocumentKeyAction("");
        }
      }
      // new mode
      else {
        setFileList(fileList.filter((f) => f?.uid !== file?.uid));

        if (type === "shop-image") {
          const keysAfterDelete = shopImagesKeys.filter(
            (key) => file?.key !== key
          );
          shopImagesKeysAction(keysAfterDelete);
        }
        if (type === "multiple-image" || type === "other-images") {
          const keysAfterDelete = multipleImagesKeys.filter(
            (key) => file?.key !== key
          );
          multipleImagesKeysAction(keysAfterDelete);
        }
        if (type === "multiple-video") {
          const keysAfterDelete = multipleVideosKeys.filter(
            (key) => file?.key !== key
          );
          multipleVideosKeysAction(keysAfterDelete);
        }
        if (type === "single-doc") {
          singleDocKeyAction("");
        }
        if (type === "featured-image") {
          featuredImageKeyAction("");
        }
        if (type === "video") {
          videoKeyAction("");
        }
        if (type === "video-cover") {
          videoCoverKeyAction("");
        }
      }
      resolve(true);
    });
  };
  return (
    <>
      {type === "shop-image" && (
        <>
          <ImgCrop
            modalTitle="برش تصویر"
            modalOk="تایید"
            modalCancel="لغو"
            resetText="لغو تغییرات"
            showGrid
            aspect={1}
            showReset
          >
            <Upload
              customRequest={customRequest}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={onRemove}
              accept=".png, .jpg, .jpeg"
              maxCount={6}
            >
              {fileList.length >= 6 ? null : (
                <div>
                  <PictureOutlined className="text-6xl text-[#7F7F7F]" />
                  {type === "multiple-image" && (
                    <p className="text-center font-body text-xs">
                      افزودن تصویر
                    </p>
                  )}
                  {type === "other-images" && (
                    <p className="text-center font-body text-xs">سایر تصاویر</p>
                  )}
                </div>
              )}
            </Upload>
          </ImgCrop>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              className="z-50 w-10/12 m-auto translate-x-3"
              percent={uploadProgress}
              status="active"
            />
          )}
          <Modal
            okButtonProps={{
              type: "primary",
              ghost: false,
              icon: <CheckOutlined />,
              style: { backgroundColor: "#005AC8", fontFamily: "IRANSansX" },
            }}
            cancelButtonProps={{
              type: "primary",
              ghost: false,
              icon: <CloseOutlined />,
              style: { backgroundColor: "#B8083D", fontFamily: "IRANSansX" },
            }}
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={() => setPreviewOpen(false)}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </>
      )}

      {(type === "multiple-image" || type === "other-images") && (
        <>
          <ImgCrop
            modalTitle="برش تصویر"
            modalOk="تایید"
            modalCancel="لغو"
            resetText="لغو تغییرات"
            showGrid
            aspect={1.25}
            showReset
          >
            <Upload
              customRequest={customRequest}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={onRemove}
              accept=".png, .jpg, .jpeg"
              maxCount={8}
            >
              {fileList.length >= 8 ? null : (
                <div>
                  <PictureOutlined className="text-6xl text-[#7F7F7F]" />
                  {type === "multiple-image" && (
                    <p className="text-center font-body text-xs">
                      افزودن تصویر
                    </p>
                  )}
                  {type === "other-images" && (
                    <p className="text-center font-body text-xs">سایر تصاویر</p>
                  )}
                </div>
              )}
            </Upload>
          </ImgCrop>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              className="z-50 w-10/12 m-auto translate-x-3"
              percent={uploadProgress}
              status="active"
            />
          )}
          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={() => setPreviewOpen(false)}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </>
      )}

      {type === "single-doc" && (
        <>
          <Upload
            listType="text"
            fileList={fileList}
            onRemove={onRemove}
            customRequest={customRequest}
            accept=".doc, .docx"
            maxCount={1}
          >
            {fileList.length > 0 ? null : (
              <div className="flex justify-center ">
                <UploadOutlined className="text-4xl text-[#0855B8]" />
              </div>
            )}
          </Upload>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              size={"small"}
              className="w-10/12 m-auto translate-x-3  z-50"
              percent={uploadProgress}
              status="active"
            />
          )}
        </>
      )}

      {(type === "featured-image" || type === "video-cover") && (
        <>
          <ImgCrop
            modalTitle="برش تصویر"
            modalOk="تایید"
            modalCancel="لغو"
            resetText="لغو تغییرات"
            showGrid
            aspect={1.8}
            showReset
          >
            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={onRemove}
              customRequest={customRequest}
              accept=".png, .jpg, .jpeg"
              maxCount={1}
            >
              {fileList.length > 0 ? null : (
                <div>
                  <PictureOutlined className="text-6xl text-[#7F7F7F]" />
                  {type === "featured-image" && (
                    <p className="text-center font-body text-xs">تصویر شاخص</p>
                  )}
                  {type === "video-cover" && (
                    <p className="text-center font-body text-xs">کاور ویدئو</p>
                  )}
                </div>
              )}
            </Upload>
          </ImgCrop>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              className="z-50 w-10/12 m-auto translate-x-3"
              percent={uploadProgress}
              status="active"
            />
          )}
          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={() => setPreviewOpen(false)}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </>
      )}

      {type === "video" && (
        <>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onRemove={onRemove}
            previewFile={(file) =>
              new Promise((resolve, reject) => {
                try {
                  var url = URL.createObjectURL(file);
                  setPreviewTitle(file?.name);
                  setPreviewVideo(url);
                  resolve(url);
                } catch {
                  reject();
                }
              })
            }
            onPreview={() => setPreviewOpen(true)}
            customRequest={customRequest}
            accept=".mp4"
            maxCount={1}
          >
            {fileList.length > 0 ? null : (
              <div>
                <CaretRightFilled className="text-6xl text-blue-500" />
                <p className="text-center font-body text-xs">افزودن ویدیو</p>
              </div>
            )}
          </Upload>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              className="z-50 w-10/12 m-auto translate-x-3"
              percent={uploadProgress}
              status="active"
            />
          )}
          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={() => setPreviewOpen(false)}
          >
            <video alt="example" style={{ width: "100%" }} controls={100}>
              <source src={previewVideo} type={previewVideo?.type} />
            </video>
          </Modal>
        </>
      )}

      {type === "multiple-video" && (
        <>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onRemove={onRemove}
            previewFile={(file) =>
              new Promise((resolve, reject) => {
                try {
                  var url = URL.createObjectURL(file);
                  setPreviewTitle(file?.name);
                  setPreviewVideo(url);
                  resolve(url);
                } catch {
                  reject();
                }
              })
            }
            onPreview={(file) => {
              if (files) {
                setPreviewTitle(file?.name);
                setPreviewVideo(file?.url);
              } else {
                var url = URL.createObjectURL(file);
                setPreviewTitle(file?.name);
                setPreviewVideo(url);
              }
              setPreviewOpen(true);
            }}
            customRequest={customRequest}
            accept=".mp4"
            maxCount={3}
          >
            {fileList.length > 3 ? null : (
              <div>
                <CaretRightFilled className="text-6xl text-blue-500" />
                <p className="text-center font-body text-xs">افزودن ویدیو</p>
              </div>
            )}
          </Upload>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <Progress
              className="z-50 w-10/12 m-auto translate-x-3"
              percent={uploadProgress}
              status="active"
            />
          )}
          {previewOpen && (
            <Modal
              open={previewOpen}
              title={previewTitle}
              footer={null}
              onCancel={() => setPreviewOpen(false)}
            >
              <video alt="example" style={{ width: "100%" }} controls={100}>
                <source src={previewVideo} type={previewVideo?.type} />
              </video>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default CustomUploader;

// to show dialog for deleting file
// onGalleryFileRemove = (file)=>{
//   const {confirm} = Modal
//   return new Promise((resolve, reject) => {
//    confirm({
//      title: 'Are you sure you want to Delete ?',
//      onOk: () => {
//        resolve(true)
//           <!---- onRemoveFunctionality here ---->
//      },
//      onCancel: () =>{
//         reject(true)
//      }
//    })
//   })
// }

// useEffect(() => {
//   if (sendFileNameMutation?.data) {
//     const url = sendFileNameMutation?.data?.url;
//     const fields = sendFileNameMutation?.data?.fields;
//     const key = sendFileNameMutation?.data?.fields?.key;

//     // edit mode
//     if (files) {
//       setNewKey(key);
//     }
//     // new mode
//     else {
//       setNewKey(key);
//       if (type === "multiple-image" || type === "other-images")
//         multipleImagesTempKeysAction([...multipleImagesTempKeys, key]);
//       if (type === "multiple-video")
//         multipleVideosTempKeysAction([...multipleVideosTempKeys, key]);
//       if (type === "single-doc") singleDocTempKeyAction(key);
//       if (type === "featured-image") featuredImageTempKeyAction(key);
//       if (type === "video") videoTempKeyAction(key);
//       if (type === "video-cover") videoCoverTempKeyAction(key);
//     }

//     let formData = new FormData();

//     Object.entries(fields).map(([key, value]) => {
//       formData.append(key, value);
//     });

//     formData.append(
//       "file",
//       tempFileList[tempFileList.length - 1].originFileObj
//     );

//     sendFileMutation.mutate({ body: formData, url: url });
//   }
// }, [sendFileNameMutation?.data]);

// const sendFileMutation = useMutation(sendFile, {
//   onSuccess: (data) => {
//     // add url property to file from tempKeys to use in removing process
//     // if (type !== "video" || type !== "multiple-video") {
//     const lastFile = tempFileList[tempFileList.length - 1];
//     const blob = new Blob([lastFile.originFileObj]);
//     const fileWithUrl = new File([blob], newKey, { type: blob.type });
//     fileWithUrl.originFileObj = lastFile.originFileObj;
//     let newTempFileListWithUrl = tempFileList.filter(
//       (tfl, i) => i !== tempFileList.length - 1
//     );
//     newTempFileListWithUrl.push(fileWithUrl);
//     setFileList(newTempFileListWithUrl);
//     // } else {
//     //   setFileList(tempFileList);
//     // }
//     setTempFileList([]);

//     // edit mode
//     if (files) {
//       if (
//         type === "multiple-image" ||
//         type === "other-images" ||
//         type === "video" ||
//         type === "multiple-video"
//       )
//         newOldKeysAction([...newOldKeys, { newKey: newKey, oldKey: oldKey }]);
//       if (type === "video-cover") newOldVideoCoverKeyAction(newKey);
//       if (type === "featured-image") newOldFeaturedImageKeyAction(newKey);
//       if (type === "single-doc") newOldDocumentKeyAction(newKey);
//       setNewKey(null);
//     }
//     // new mode
//     else {
//       if (type === "multiple-image" || type === "other-images")
//         multipleImagesKeysAction(multipleImagesTempKeys);
//       if (type === "multiple-video")
//         multipleVideosKeysAction(multipleVideosTempKeys);
//       if (type === "single-doc") singleDocKeyAction(singleDocTempKey);
//       if (type === "featured-image")
//         featuredImageKeyAction(featuredImageTempKey);
//       if (type === "video") videoKeyAction(videoTempKey);
//       if (type === "video-cover") videoCoverKeyAction(videoCoverTempKey);
//     }
//   },
//   onError: () => {
//     setTempFileList([]);
//     // edit mode
//     if (files) {
//       setNewKey(null);
//     }
//     // new mode
//     else {
//       if (type === "multiple-image" || type === "other-images")
//         multipleImagesTempKeysAction([]);
//       if (type === "multiple-video") multipleVideosTempKeysAction([]);
//       if (type === "single-doc") singleDocTempKeyAction("");
//       if (type === "featured-image") featuredImageTempKeyAction("");
//       if (type === "video") videoTempKeyAction("");
//       if (type === "video-cover") videoCoverTempKeyAction("");
//     }
//   },
// });

// const handleChange = ({ file, fileList }) => {
//   const isAdded = fileList.some((f) => f.uid === file.uid);

//   // edit mode
//   if (files) {
//     if (isAdded) {
//       sendFileNameMutation.mutate({
//         body: { filename: file?.name },
//         listOfFiles: fileList,
//       });
//     }
//     // new mode
//   } else {
//     if (isAdded) {
//       sendFileNameMutation.mutate({
//         body: { filename: file?.name },
//         listOfFiles: fileList,
//       });
//     }
//   }
// };

// const sendFileNameMutation = useMutation(({ body }) => sendFileName(body), {
//   onSuccess: (data, { listOfFiles }) => {
//     setTempFileList(listOfFiles);
//     // new mode
//     if (!files) {
//       if (type === "multiple-image" || type === "other-images")
//         multipleImagesTempKeysAction(multipleImagesKeys);
//       if (type === "multiple-video")
//         multipleVideosTempKeysAction(multipleVideosKeys);
//       if (type === "single-doc") singleDocTempKeyAction(singleDocKey);
//       if (type === "featured-image")
//         featuredImageTempKeyAction(featuredImageKey);
//       if (type === "video") videoTempKeyAction(videoKey);
//       if (type === "video-cover") videoCoverTempKeyAction(videoCoverKey);
//     }
//   },
// });

// const onRemove = (file) => {
//   return new Promise((resolve, reject) => {
//     // edit mode
//     if (files) {
//       setFileList(fileList.filter((f) => f?.uid !== file?.uid));
//       setTempFileList([]);

//       if (
//         type === "multiple-image" ||
//         type === "other-images" ||
//         type === "video" ||
//         type === "multiple-video"
//       ) {
//         // old files
//         if (file?.url) {
//           newOldKeysAction([
//             ...newOldKeys,
//             {
//               newKey: newKey,
//               oldKey: file?.url?.replace(
//                 process.env.REACT_APP_ARVAN_S3_BASE_URL,
//                 ""
//               ),
//             },
//           ]);
//         }
//         // new files
//         else {
//           newOldKeysAction([
//             ...newOldKeys,
//             { newKey: newKey, oldKey: file?.name },
//           ]);
//         }
//       }

//       if (type === "video-cover") {
//         newOldVideoCoverKeyAction(newKey);
//       }
//       if (type === "featured-image") {
//         newOldFeaturedImageKeyAction(newKey);
//       }
//       if (type === "single-doc") {
//         newOldDocumentKeyAction(newKey);
//       }
//     }
//     // new mode
//     else {
//       setFileList(fileList.filter((f) => f?.uid !== file?.uid));
//       setTempFileList([]);
//       const keysAfterDelete = multipleImagesKeys.filter(
//         (key) => file.name !== key
//       );
//       if (type === "multiple-image" || type === "other-images") {
//         multipleImagesKeysAction(keysAfterDelete);
//         multipleImagesTempKeysAction(keysAfterDelete);
//       }
//       if (type === "multiple-video") {
//         multipleVideosKeysAction(keysAfterDelete);
//         multipleVideosTempKeysAction(keysAfterDelete);
//       }
//       if (type === "single-doc") {
//         singleDocKeyAction("");
//         singleDocTempKeyAction("");
//       }
//       if (type === "featured-image") {
//         featuredImageKeyAction("");
//         featuredImageTempKeyAction("");
//       }
//       if (type === "video") {
//         videoKeyAction("");
//         videoTempKeyAction("");
//       }
//       if (type === "video-cover") {
//         videoCoverKeyAction("");
//         videoCoverTempKeyAction("");
//       }
//     }
//     resolve(true);
//   });
// };
